<app-modal #modal [dismissible]="true" [isLoading]="isLoading">
    <ng-container modal-header>
        <h5 class="modal-title">{{ 'admin.strain.tickets.reports.modal.step3.sampleBoardLoad.title' | translate }}</h5>
    </ng-container>
    <ng-container modal-body>
        <app-dropdown-autocomplete
            valueField="id"
            displayField="name"
            [items]="availableSampleBoards"
            [appendTo]="'body'"
            [formControl]="sampleBoardSelectorControl"
            [emptyText]="'admin.strain.tickets.reports.modal.step3.sampleBoardLoad.placeholder' | translate">
        </app-dropdown-autocomplete>
    </ng-container>
    <ng-container modal-footer>
        <app-button type="simple" (clicked)="close()">
            {{ 'generic.buttons.cancel' | translate }}
        </app-button>
        <app-button type="primary"
                    [disabled]="sampleBoardSelectorControl.invalid || isLoading"
                    (clicked)="onLoadClicked()">
            {{ 'generic.buttons.load' | translate }}
        </app-button>
    </ng-container>
</app-modal>
